<template lang="pug">
  Modal(
    name="invite-friends-modal"
    align="center"
    ref="modal"
  )
    .modal__heading.modal__item
      .modal__top-img
        img(:src="$getTenantImg('shareModal')" alt="")
      h3.modal__title Пригласите друзей
      .modal__subtitle Отправьте друзьям ссылку для&nbsp;вступления в&nbsp;клуб
    .modal__body.modal__item
      .block-text.block-text_primary
        .steps-text
          .steps-text__item
            .input(
              v-clipboard="() => refLink"
              v-clipboard:success="refLinkCopied"
            )
              input.input__el(
                :value="refLink"
                readonly
                style="pointer-events: none"
              )
              .input__icons
                button.input__icon
                  icon(icon-name='copy')
              .input__border
          .steps-text__item
            .heading-line.text-center
              span.heading-line__text или поделитесь в соцсетях
          .steps-text__item
            YandexShare(:link="refLink")
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '@/components/Modal.vue'
import YandexShare from '@/components/YandexShare'

export default {
  name: 'InviteFriendsModal',
  components: {
    Modal,
    YandexShare
  },
  data () {
    return {
      refLink: window.location.origin + this.$route.path
    }
  },
  methods: {
    ...mapActions('alerts', ['addSuccessAlert']),
    refLinkCopied () {
      this.addSuccessAlert('Ссылка скопирована')
    }
  }
}
</script>
